<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-cmsres__cmsres}">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="采集源ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('cmsres:cmsres:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('cmsres:cmsres:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="id" label="采集源ID" header-align="center" align="center"></el-table-column>
        <el-table-column prop="listJson" label="列表URL" header-align="center" align="center"></el-table-column>
        <el-table-column prop="detailJson" label="详情URL" header-align="center" align="center"></el-table-column>
        <el-table-column prop="resName" label="采集源名字" header-align="center" align="center"></el-table-column>
        <el-table-column prop="type" label="第一次采集状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.type == 0" type="success">未采集过全部</el-tag>
            <el-tag v-if="scope.row.type == 1" type="success">正在采集全部</el-tag>
            <el-tag v-if="scope.row.type == 2" type="success">采集全部完毕</el-tag>
        </template>
        </el-table-column>
        <el-table-column prop="status" label="使用状态" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status == 0" type="success">使用中</el-tag>
            <el-tag v-if="scope.row.status == 1" type="success">未使用</el-tag>
        </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('cmsres:cmsres:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>|
            <el-button  type="text" size="small" @click="bangdingClass(scope.row.id)">绑定分类</el-button>|
            <el-button  type="text" size="small" @click="InfoHandle(scope.row.id)">查看采集源资源</el-button>|
            <el-button v-if="$hasPermission('cmsres:cmsres:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="refreshDataList"></add-or-update>
      <!-- 弹窗, 日志列表 -->
      <Info v-if="InfoVisible" ref="Info"></Info>
      <cmsc v-if="cmscVisible" ref="cmsc"></cmsc>
    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './cmsres-add-or-update'
import cmsc from './cms-clas'
import Info from './cms-info'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      mixinViewModuleOptions: {
        getDataListURL: '/cmsres/cmsres/page',
        getDataListIsPage: true,
        exportURL: '/cmsres/cmsres/export',
        deleteURL: '/cmsres/cmsres',
        deleteIsBatch: true
      },
      dataForm: {
        id: ''
      },
      InfoVisible: false,
      cmscVisible:false

    }
  },
  components: {
    AddOrUpdate,
    cmsc,
    Info
  },
  methods: {
    InfoHandle(id){
      this.InfoVisible = true
      this.$nextTick(() => {
        this.$refs.Info.dataForm.id = id
        this.$refs.Info.init()
      })
    },
    bangdingClass(id){
      this.cmscVisible = true
      this.$nextTick(() => {
        this.$refs.cmsc.dataForm.id = id
        this.$refs.cmsc.init()
      })
    }
  }
}
</script>
